// Sometimes we only output the city and state
// but only show the city if it's diff than eht eshcool name
// i intneded to support that funcationality throught the optoins param

interface IFormattedAddressOptions {
  schoolName?: string;
}

export const getFormattedAddress = (
  address?: string,
  city?: string,
  state?: string,
  zip?: string | number,
  options: IFormattedAddressOptions = {}
): string => {
  const formattedCity = city !== options.schoolName ? city : null;
  return (
    (address ? address + (state || formattedCity || zip ? ', ' : '') : '') +
    (formattedCity ? formattedCity + (state || zip ? ', ' : '') : '') +
    (state ? state + (zip ? ', ' : '') : '') +
    (zip || '')
  ).trim();
};

/*
// not currently used but uncomment if needed and should work
const getFormattedAddressElement = (
  address,
  city,
  state,
  zip,
  options = {}
) => {
  let addressElement = null;
  if (address) {
    addressElement = <div className="address">{address}</div>;
  }

  const formattedCity = city !== options.schoolName ? city : null;
  const formattedState = (state ?? '').trim();

  let secondRow = null;
  if (formattedCity || formattedState || zip) {
    secondRow = (
      <div className="city-state-zip">
        {formattedCity
          ? `${formattedCity}${formattedState || zip ? ', ' : ''}`
          : null}
        {formattedState ? `${formattedState}${zip ? ', ' : ''}` : null}
        {zip || null}
      </div>
    );
  }

  if (!addressElement && !secondRow) {
    return null;
  }

  return (
    <address className={options?.className}>
      {addressElement}
      {secondRow}
    </address>
  );
};

export default getFormattedAddressElement;
*/
